import { createContext, useContext, ReactNode } from 'react';

interface PCSWidgetContextType {
  widgetId?: string;
  isUnitScope?: boolean;
}

const PCSWidgetContext = createContext<PCSWidgetContextType | undefined>(
  undefined,
);

export const PCSWidgetProvider = ({
  children,
  widgetId,
  isUnitScope,
}: {
  children: ReactNode;
  widgetId?: string;
  isUnitScope?: boolean;
}) => {
  return (
    <PCSWidgetContext.Provider value={{ widgetId, isUnitScope }}>
      {children}
    </PCSWidgetContext.Provider>
  );
};

export const usePCSWidget = () => {
  const context = useContext(PCSWidgetContext);
  if (context === undefined) {
    throw new Error('usePCSWidget must be used within a PCSWidgetProvider');
  }
  return context;
};
